import styled from 'styled-components';
import checkIcon from 'images/icons/check.svg';

const iconMap = {
  check: checkIcon,
};

/* ACTION BUTTONS */
export const StyledActionButton = styled.span`
  display: inline-block;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 1px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 8px 14px;
  margin: 4px 8px 4px 0;
  border-radius: 20px;
  position: relative;
  line-height: 13px;
  height: 28px;
  font-size: 9px;
  border: ${({ theme }) => `1px solid ${theme.colors.palette[7]}}`};
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  color: #fff;
  background-color: transparent;

  &:hover {
    background-color: ${({ theme }) => theme.colors.palette[7]};
  }

  &:nth-child(1) {
    border: ${({ theme }) => `1px solid ${theme.colors.palette[5]}}`};
    background-color: ${({ selected, theme }) => selected && `${theme.colors.palette[5]};`}
  }

  &:nth-child(2) {
    background-color: ${({ selected, theme }) => selected && `${theme.colors.palette[7]};`}
  }

  &:nth-child(1):hover {
    background-color: ${({ theme }) => theme.colors.palette[5]};
  }
`;

export const StyledIcon = styled.div`
  display: inline-block;
  margin-right: 11px;
  width: ${({ width }) => width || '8px'};
  height: ${({ height }) => height || '8px'};;
  background: ${({ icon }) => `url('${iconMap[icon]}')`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const HeaderActionButtonContainer = styled.div`
  display: block;
  margin-top: 15px;
`;
